import React, { useState } from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { Dropdown } from "../../components/ui/Dropdown/Dropdown";
import { PatientTable } from "./Patient/patient-table";
import { useNavigate } from "react-router-dom";

const searchPatientByOptions = [
  {
    id: "name",
    name: "환자명",
  },
  {
    id: "phone",
    name: "휴대전화 번호",
  },
];

const patientOptions = [
  { id: "LATEST", name: "최신순" },
  { id: "OLDEST", name: "등록일시순" },
];

const PatientPage = () => {
  const [filter, setFilter] = useState({ orderBy: "LATEST" });
  const [keyword, setKeyword] = useState("");
  const [searchPatientBy, setSearchPatientBy] = useState("name");
  const navigate = useNavigate();

  const onChangeSearchPatientBy = (id) => {
    setSearchPatientBy(id);
  };

  const onChangeKeyword = (e) => {
    setKeyword(e.target.value);
  };

  const handleSearchByKeyword = (e) => {
    e.preventDefault();
    const { orderBy } = filter;
    setFilter({
      orderBy,
      [searchPatientBy]: keyword,
    });
  };

  const onResetFilter = () => {
    setKeyword("");
    setFilter({
      orderBy: "LATEST",
    });
  };

  return (
    <div>
      <TitlePage title="회원조회" />
      <div className="mt-5">
        <div className="flex justify-between h-9 mb-[15px]">
          <div className="flex gap-[14px]">
            <div className="flex">
              <div
                onClick={() => navigate("/hospital")}
                className={`cursor-pointer w-[150px] flex justify-center items-center text-[#999999] border border-[#dddddd] p-[5px]`}
              >
                병원회원
              </div>
              <div
                className={`cursor-pointer w-[150px] flex justify-center items-center bg-primary-blue text-white p-[5px]`}
              >
                환자회원
              </div>
            </div>
            <div className="flex w-[27rem] gap-2">
              <Dropdown
                textColor="text-black"
                height="h-9"
                width="w-44"
                placeholder="환자명"
                positionDropdown={`top-11`}
                options={searchPatientByOptions}
                onClickItem={(id) => onChangeSearchPatientBy(id)}
              />
              <form onSubmit={handleSearchByKeyword} className="flex">
                <div className="relative">
                  <input
                    type="text"
                    className="w-[220px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0"
                    placeholder="검색어 입력"
                    onChange={onChangeKeyword}
                    value={keyword}
                  />
                  <div
                    onClick={onResetFilter}
                    className={`text-[#3E6AB1] font-bold cursor-pointer absolute top-1/2 right-2 transform -translate-x-1/2 -translate-y-1/2 ${
                      keyword?.length ? "block" : "hidden"
                    }`}
                  >
                    X
                  </div>
                </div>
                <button
                  type="submit"
                  className="cursor-pointer bg-[#19459f] p-2 border-r border-[#19459f] rounded-r-[4px]"
                >
                  <HiMagnifyingGlass
                    onClick={handleSearchByKeyword}
                    className="text-white text-[18px] m-auto"
                  />
                </button>
              </form>
            </div>
          </div>
          <div>
            <Dropdown
              height="h-9"
              width="w-32"
              placeholder="최신순"
              options={patientOptions}
              positionDropdown={"top-11"}
              onClickItem={(id) => setFilter({ ...filter, orderBy: id })}
            />
          </div>
        </div>
        <PatientTable filter={filter} />
      </div>
    </div>
  );
};

export default PatientPage;
